import { UserDefinedTemplate } from './types';
import { getAuthContext } from '../../utils/jwt';
import { BASE_URL } from '../../utils/constants';


export const updateTemplateStatus = async (
  templateId: string,
  status: 'APPROVED' | 'REJECTED',
  template: UserDefinedTemplate
): Promise<{ success: boolean }> => {
  const payload = {
    name: template.name,
    description: template.description || '',
    status,
  };

  try {
    // Get auth context
    const { token, tenantId, userId } = getAuthContext();

    const response = await fetch(
      `${BASE_URL}/v1/templates/user-define/${templateId}`,
      {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-Tenant-Id': tenantId || '',
          'X-User-Id': userId || '',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      }
    );

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        errorData.message || `HTTP error! status: ${response.status}`
      );
    }

    return { success: true };
  } catch (error) {
    // console.error('Failed to update template status:', error);
    throw error;
  }
};
